import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";
import { AlertTriangle, XCircle, Info, CheckCircle2 } from "lucide-react";

export function AlertDialogs(props) {
  const { t } = useTranslation();
  const { lang } = indexStore();

  // Determine variant for styling
  const variant = props.variant || "default";
  
  const getVariantStyles = () => {
    switch (variant) {
      case "destructive":
        return {
          icon: <XCircle className="w-5 h-5 text-red-600 dark:text-red-400" />,
          iconBg: "bg-red-100 dark:bg-red-900/30",
          titleColor: "text-red-900 dark:text-red-100",
        };
      case "warning":
        return {
          icon: <AlertTriangle className="w-5 h-5 text-amber-600 dark:text-amber-400" />,
          iconBg: "bg-amber-100 dark:bg-amber-900/30",
          titleColor: "text-amber-900 dark:text-amber-100",
        };
      case "info":
        return {
          icon: <Info className="w-5 h-5 text-blue-600 dark:text-blue-400" />,
          iconBg: "bg-blue-100 dark:bg-blue-900/30",
          titleColor: "text-blue-900 dark:text-blue-100",
        };
      case "success":
        return {
          icon: <CheckCircle2 className="w-5 h-5 text-green-600 dark:text-green-400" />,
          iconBg: "bg-green-100 dark:bg-green-900/30",
          titleColor: "text-green-900 dark:text-green-100",
        };
      default:
        return {
          icon: <AlertTriangle className="w-5 h-5 text-amber-600 dark:text-amber-400" />,
          iconBg: "bg-amber-100 dark:bg-amber-900/30",
          titleColor: "text-foreground",
        };
    }
  };

  const variantStyles = getVariantStyles();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{props.trigger}</AlertDialogTrigger>
      <AlertDialogContent
        dir={lang === "ar" ? "rtl" : "ltr"}
        className="max-w-md"
      >
        <AlertDialogHeader>
          <div className={`flex items-start gap-4 ${lang === "ar" ? "flex-row-reverse" : ""}`}>
            <div className={`p-2.5 rounded-lg ${variantStyles.iconBg} shrink-0`}>
              {variantStyles.icon}
            </div>
            <div className="flex-1">
              <AlertDialogTitle className={`text-lg font-semibold ${variantStyles.titleColor}`}>
                {props.title}
              </AlertDialogTitle>
              <AlertDialogDescription className="mt-2 text-sm text-muted-foreground">
                {props.description}
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        {props.children && (
          <div className={`px-2 ${lang === "ar" ? "text-right" : "text-left"}`}>
            {props.children}
          </div>
        )}
        <AlertDialogFooter className={lang === "ar" ? "flex-row-reverse gap-2" : "gap-2"}>
          <AlertDialogCancel className="m-0">{t("gloabl.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={props.onClickOk}
            className={variant === "destructive" ? "bg-red-600 hover:bg-red-700 m-0" : "m-0"}
          >
            {t("gloabl.yes")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
